module.exports = __webpack_public_path__ + "img/ad-3.f1bbad6f.png";